// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__w6Pjo","image":"Icon_image__k8Wh3"};